import type {
  InsightsFilterInput,
  PostType,
  TagComparator,
} from '../graphqlEnums'
import { toUTCDayEnd, toUTCDayStart } from './toUTCDayBounds'

interface BuildInsightsFilterInputOptions {
  organizationId: string
  startDate: Date
  endDate: Date
  channelIds?: string[]
  tags?: TagComparator
  postTypes?: readonly PostType[]
}

export function buildInsightsFilterInput({
  organizationId,
  startDate,
  endDate,
  channelIds,
  tags,
  postTypes,
}: BuildInsightsFilterInputOptions): InsightsFilterInput {
  return {
    organizationId,
    startDate: toUTCDayStart(startDate),
    endDate: toUTCDayEnd(endDate),
    ...(channelIds?.length ? { channelIds } : {}),
    ...(tags ? { tags } : {}),
    ...(postTypes?.length ? { postTypes: [...postTypes] } : {}),
  }
}
